export const CASHBACK_GROWTH_FEATURE_FLAG = 'PR-4836-cashback-growth' as const;

export const PLANNE_CONCIERGE_PHONE_NUMBER = '5554936188369';
export const CASHBACK_MODAL_OPEN_DELAY_MS = 1500;
export const CASHBACK_CONFETTI_DELAY_MS = 450;
